import { Box, Icon, Typography } from "@outschool/backpack";
import { PublicReviewFragmentFragment } from "@outschool/gql-frontend-generated";
import { faEdit } from "@outschool/icons";
import { useTranslation } from "@outschool/localization";
import { sectionFeedbackPath } from "@outschool/routes";
import { Screen, useLinkComponent } from "@outschool/ui-utils";
import React from "react";

type EditReviewButtonProps = {
  activity: PublicReviewFragmentFragment["activity"];
  review: PublicReviewFragmentFragment;
};

export const EditReviewButton: React.FunctionComponent<
  EditReviewButtonProps
> = ({ activity, review }) => {
  const { t } = useTranslation(
    "ui-components-website\\Reviews\\MoreOptionsButton\\MoreOptionsMenuButtons\\EditReviewButton",
  );
  const isMobile = Screen.useIsMobile();
  const Link = useLinkComponent();

  const sectionFeedbackRoute = React.useMemo(
    //@ts-ignore
    () => sectionFeedbackPath(activity, review.section_uid),
    [activity, review.section_uid],
  );

  return (
    <Box
      sx={{
        margin: "16px",
      }}
    >
      <Link to={sectionFeedbackRoute}>
        <Typography
          variant="inherit"
          sx={{
            color: isMobile ? "primary.700" : "#2E3238",
          }}
        >
          <Icon
            icon={faEdit}
            sx={{
              marginRight: "0.5em",
            }}
          />
          {t`Edit`}
        </Typography>
      </Link>
    </Box>
  );
};
